import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JourneySelect from '../../components/regular_shuttle/JourneySelect';
import isEmpty from 'lodash/isEmpty';

export default class JourneySelectContainer extends Component {
    static propTypes = {
        id: PropTypes.string,
        lines: PropTypes.array,
        onChangeDeparture: PropTypes.func,
        onChangeArrival: PropTypes.func,
        onChangeTime: PropTypes.func,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        focused: PropTypes.bool,

        // Injected by redux-form
        input: PropTypes.object,
        meta: PropTypes.object
    };

    static defaultProps = {
        id: null,
        lines: [],
        focused: false,
        onChange: () => {},
        onChangeDeparture: () => {},
        onChangeArrival: () => {},
        onChangeTime: () => {},
        onBlur: () => {}
    };

    constructor(props) {
        super(props);

        this.state = {
            expand: false,
            focusedInput: props.focused ? 'departure' : null
        };
    }

    componentDidMount() {
        const { value } = this.props.input;
        const expand = !isEmpty(value) && !isEmpty(value.departure);
        this.setState({ ...this.state, expand });
    }

    /*componentWillReceiveProps(nextProps) {
        const { value } = nextProps.input;
        const expand = !isEmpty(value) && !isEmpty(value.departure);

        this.setState({ expand });
    }*/

    handleDepartureChange(value) {
        const expandsAndFocusArrivalInput = !isEmpty(value);

        this.setState({
            expand: expandsAndFocusArrivalInput,
            focusedInput: expandsAndFocusArrivalInput ? 'arrival' : null
        });

        const newValue = {
            departure: value,
            arrival: null,
            time: null
        };

        this.props.input.onChange(newValue);
        this.props.onChangeDeparture(value);
        this.props.onChange(newValue);
    }

    handleArrivalChange(value) {
        const newValue = {
            ...this.props.input.value,
            arrival: value,
            time: null
        };

        this.props.input.onChange(newValue);
        this.props.onChangeArrival(value);
        this.props.onChange(newValue);
    }

    handleTimeChange(value) {
        const newValue = {
            ...this.props.input.value,
            time: value
        };

        this.props.input.onChange(newValue);
        this.props.onChangeTime(value);
        this.props.onChange(newValue);
    }

    render() {
        const { onBlur, input, ...others } = this.props;
        const { expand, focusedInput } = this.state;

        return (
            <JourneySelect
                {...others}
                expand={expand}
                departure={{
                    value: input.value.departure,
                    onChange: ::this.handleDepartureChange,
                    onBlur: onBlur,
                    focused: 'departure' === focusedInput
                }}
                arrival={{
                    value: input.value.arrival,
                    onChange: ::this.handleArrivalChange,
                    onBlur: onBlur,
                    focused: 'arrival' === focusedInput
                }}
                time={{
                    value: input.value.time,
                    onChange: ::this.handleTimeChange,
                }}
            />
        );
    }
}
